import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { ROUTER_GROUP, ROUTER_PRODUCT } from "helpers/router_helper"
import { VIEW_GROUP_NGO } from "helpers/view_helper"
import { isEqual } from "lodash"

import { Button, Card, CardBody, CardTitle, Alert, UncontrolledAlert, Row, Col } from "reactstrap"
import { VIEW_GROUP_CLINIC, VIEW_GROUP_DOCTOR, VIEW_GROUP_HOSPITAL, VIEW_GROUP_UNIVERSITY } from "../../helpers/view_helper"


class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
  }

  componentDidMount() {
    this.initMenu()
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu()
    }
  }

  initMenu() {
    new MetisMenu("#side-menu")

    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      } else if ((this.props.location.pathname).indexOf("/users-birthchart") > -1) {
        matchingMenuItem = items[1]
      } else {
        matchingMenuItem = items[2]
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300
          }
        }
      }
    }, 300)
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      this.scrollElement(item)
      return false
    }
    this.scrollElement(item)
    return false
  }

  render() {
    let userRoles = {
      user: false,
      productAdmin: false,
      isGRPGroupAdmin: false,
      isGRPBranchAdmin: false,
      isGRPGroupUser: false,
    }

    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }

    let groupType = "none"

    if (sessionStorage.getItem("groupType")) {
      groupType = JSON.parse(sessionStorage.getItem("groupType"));
      groupType = JSON.parse(sessionStorage.getItem("groupType")).groupType;
    }

    return (
      <React.Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
          <div id="sidebar-menu">
            {userRoles.user && (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="bx bxs-dashboard" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to="/generate-birthchart" className="waves-effect">
                    <i className="bx bxs-doughnut-chart" />
                    <span>Generate AI Report</span>
                  </Link>
                </li>
                <li>
                  <Link to="/birthchart-report" className="waves-effect">
                    <i className="bx bx-windows" />
                    <span>View AI Reports</span>
                  </Link>
                </li>
              </ul>
            )}

            {userRoles.productAdmin && (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link to={`${ROUTER_PRODUCT}/dashboard`} className="waves-effect">
                    <i className="bx bxs-dashboard" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_PRODUCT}/report-upload`} className="waves-effect">
                    <i className="bx bx-upload" />
                    <span>Report Upload</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="bx bx-windows" />
                    <span>View AI Reports</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={`${ROUTER_PRODUCT}/users-birthchart`}>Astro User</Link>
                    </li>
                    <li>
                      <Link to={`${ROUTER_PRODUCT}/group-reports`}>Group</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="bx bx-key" />
                    <span>User Management</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={`${ROUTER_PRODUCT}/astrouser-list`}>Astro User</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            )}

            {userRoles.isGRPGroupAdmin && (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">My Activities</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/dashboard`} className="">
                    <i className="bx bxs-grid-alt" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/profile`} className="">
                    <i className="bx bxs-user-detail" />
                    <span>Profile</span>
                  </Link>
                </li>
                <li className="menu-title">Reports</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/report`} className="waves-effect">
                    <i className="bx bxs-receipt" />
                    <span>View AI Reports</span>
                  </Link>
                </li>
                <li className="menu-title">Administration</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/organisation`} className="">
                    <i className="bx bxs-rocket" />
                    <span>Organisation</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/branches`} className="">
                    <i className="bx bxs-vector" />
                    <span>Branches</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/users`} className="">
                    <i className="bx bxs-user-pin" />
                    <span>Users</span>
                  </Link>
                </li>

              </ul>
            )}

            {userRoles.isGRPBranchAdmin && (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">My Activities</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/dashboard`} className="">
                    <i className="bx bxs-grid-alt" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/profile`} className="">
                    <i className="bx bxs-user-detail" />
                    <span>Profile</span>
                  </Link>
                </li>
                <li className="menu-title">Reports</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/report`} className="waves-effect">
                    <i className="bx bxs-receipt" />
                    <span>View AI Reports</span>
                  </Link>
                </li>
                <li className="menu-title">Administration</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/organisation`} className="">
                    <i className="bx bxs-rocket" />
                    <span>Organisation</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/branch`} className="">
                    <i className="bx bxs-vector" />
                    <span>Branch</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/users`} className="">
                    <i className="bx bxs-user-pin" />
                    <span>Users</span>
                  </Link>
                </li>
              </ul>
            )}

            {userRoles.isGRPGroupUser && (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">My Activities</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/dashboard`} className="">
                    <i className="bx bxs-grid-alt" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/profile`} className="">
                    {isEqual(groupType, VIEW_GROUP_NGO) &&
                      (<span className="badge rounded-pill bg-success float-end">
                        NGO
                      </span>)}
                      {isEqual(groupType, VIEW_GROUP_DOCTOR) &&
                      (<span className="badge rounded-pill bg-success float-end">
                        Doctor
                      </span>)}
                      {isEqual(groupType, VIEW_GROUP_UNIVERSITY) &&
                      (<span className="badge rounded-pill bg-success float-end">
                        University
                      </span>)}
                      {isEqual(groupType, VIEW_GROUP_CLINIC) &&
                      (<span className="badge rounded-pill bg-success float-end">
                        Clinic
                      </span>)}
                      {isEqual(groupType, VIEW_GROUP_HOSPITAL) &&
                      (<span className="badge rounded-pill bg-success float-end">
                        Hospital
                      </span>)}
                    <i className="bx bxs-user-detail" />
                    <span>Profile</span>
                  </Link>
                </li>
                <li className="menu-title">Reports</li>

                {/* {isEqual(groupType, VIEW_GROUP_NGO) ? (<li>
                  <Link to={`${ROUTER_GROUP}/generate-report/NGO`} className="waves-effect">
                    <i className="bx bxs-report" />
                    <span>Generate AI Report</span>
                  </Link>
                </li>) : (<li>
                  <Link to={`${ROUTER_GROUP}/generate-report`} className="waves-effect">
                    <i className="bx bxs-report" />
                    <span>Generate AI Report</span>
                  </Link>
                </li>)} */}
                <li>
                  <Link to={`${ROUTER_GROUP}/generate-report`} className="waves-effect">
                    <i className="bx bxs-report" />
                    <span>Generate AI Report</span>
                  </Link>
                </li>

                <li>
                  <Link to={`${ROUTER_GROUP}/report`} className="waves-effect">
                    <i className="bx bxs-receipt" />
                    <span>View AI Reports</span>
                  </Link>
                </li>
                <li className="menu-title">Management</li>
                <li>
                  <Link to={`${ROUTER_GROUP}/organisation`} className="">
                    <i className="bx bxs-rocket" />
                    <span>Organisation</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${ROUTER_GROUP}/branch`} className="">
                    <i className="bx bxs-vector" />
                    <span>Branch</span>
                  </Link>
                </li>
              </ul>
            )}
          </div>
          {/* {isEqual(groupType, VIEW_GROUP_NGO) && (
            <Alert color="success text-center">
              Narayana
            </Alert>
          )} */}

          {/* {isEqual(groupType, VIEW_GROUP_NGO) && (
            <div className="card bg-primary">
              <CardBody>
                <CardTitle className="h4">Narayana</CardTitle>
                <p className="card-title-desc">
                  Align terms and descriptions horizontally by using our
                  grid system’s predefined classNamees.
                    </p>
              </CardBody>
            </div>
          )} */}

          {/* {isEqual(groupType, VIEW_GROUP_NGO) && (
            <div className="card-radio">
              <div className="text-center">
                <span className="">NGO</span>
              </div>
            </div>
          )} */}
        </SimpleBar >
      </React.Fragment >
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
}

export default withRouter(SidebarContent)
